export const ROUTE_LOGIN_OUT = "/login";
export const ROUTE_LOGGING_IN = "/auth/:jwt?";
export const ROUTE_HOME = "/dashboard";
export const ROUTE_ITEM = "/item";
export const ROUTE_QUOTATION_MANAGEMENT = "/quotation-management";
export const ROUTE_PRICING_LEAD_TIME_ESTIMATION =
  "/pricing-lead-time-estimation";
export const ROUTE_ORDER_MANAGEMENT = "/order-management";
export const ROUTE_REPORTS_LIST = "/reports-list";
export const ROUTE_USER_MANAGEMENT = "/user-management";
export const ROUTE_ADMIN_MANAGEMENT = "/admin-management";
export const ROUTE_PROFILE = "/profile";
export const ROUTE_MERGE_COMPANIES = "/merge-companies";

// Route Params
export const ROUTE_PARAM_MERGE_COMPANIES_USER_ID_KEEP = "userKeepID";
export const ROUTE_PARAM_MERGE_COMPANIES_USER_ID_REMOVE = "userRemoveID";
